<!-- =========================================================================================
    File Name: Category.vue
    Description: Category demo - Imports all Category demos
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="table-demo" v-if="objectsReadPermission">
		<bread-crumbs
			:title="$t('ListOfObjects')"
			:subTitle="$t('general.SubTitleObject')"
			:sizeTitle="30"
			:lineHeightTitle="37"
			:sizeSubTitle="15"
			:lineHeightSubTitle="18"
		>
		</bread-crumbs>
		<vs-input icon-no-border :placeholder="$t('Search')" v-model="searchQuery" class="w-full mb-4" />
		<category-default
			v-for="category in listCategoriesDataFilter"
			:key="category.id"
			:schema="category"
			:additionalFields="false"
			:showEditIcon="true"
			defaultAction="LIST"
		></category-default>
	</div>
	<not-permission v-else></not-permission>
</template>

<script>
import moduleCategory from "@/store/category/moduleCategory.js";
import moduleTipology from "@/store/tipology/moduleTipology.js";
import CategoryDefault from "./CategoryDefault.vue";
import NotPermission from "@/views/pages/NotPermission.vue";

export default {
	name: "Category",
	data() {
		return {
			typology_data: null,
			categories: [],
			searchQuery: null,
		};
	},
	components: {
		CategoryDefault,
		NotPermission,
	},
	computed: {
		listCategories() {
			return this.$store.state.moduleCategory.categories.map((category) => ({
				...category,
				typologyData: this.findTypology(category.typology_id),
			}));
		},
		objectsReadPermission() {
			return this.$store.getters.checkPermission("OBJECTS_R");
		},
		listCategoriesDataFilter() {
			const data = this.listCategories;
			if (!this.searchQuery || this.searchQuery.trim().length <= 0) {
				return data;
			}
			return data.filter((r) => {
				return (
					r.typologyData.name.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
					r.name.toLowerCase().includes(this.searchQuery.toLowerCase())
				);
			});
		},
	},
	methods: {
		openLoading() {
			this.$vs.loading();
		},
		closeLoading() {
			this.$vs.loading.close();
		},
		create() {
			this.$refs.CategoryDefault.setValue(2.0);
		},
		fetchCategory() {
			if (this.$store.state.moduleCategory.categories.length > 0) return;
			this.$store.dispatch("moduleCategory/fetchCategory").then((response) => {
				this.categories = response.data;
			});
		},
		findTypology(typologyId) {
			const foundTypology = this.$store.state.moduleTipology.tipologies.find(
				(typology) => typology.id === typologyId
			);
			return (
				foundTypology || {
					added_on: "2020-10-26 22:58:43",
					company_id: 0,
					description: "",
					id: 0,
					name: "",
					update_on: null,
				}
			);
		},
	},
	created() {
		if (!moduleCategory.isRegistered) {
			this.$store.registerModule("moduleCategory", moduleCategory);
			moduleCategory.isRegistered = true;
		}
		if (!moduleTipology.isRegistered) {
			this.$store.registerModule("moduleTipology", moduleTipology);
			moduleTipology.isRegistered = true;
		}
		this.openLoading();
		this.$store
			.dispatch("moduleTipology/fetchTypology")
			.then((res) => {
				if (this.$store.state.moduleCategory.categories.length > 0) {
					return this.$store.state.moduleCategory.categories;
				} else {
					return this.$store.dispatch("moduleCategory/fetchCategory");
				}
			})
			.then((response) => {
				this.categories = response.data;
				this.closeLoading();
			})
			.catch((err) => {
				this.closeLoading();
				throw new Error(err);
			});
	},
};
</script>
